import {createAction} from 'redux-act';

export const setEnvironment = createAction('Set Environment', (environment) => ({environment}));
